import { render } from "./document.vue?vue&type=template&id=5b4fec96&scoped=true"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"

import "./document.vue?vue&type=style&index=0&id=5b4fec96&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4fec96"],['__file',"src/views/document.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4fec96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4fec96', __exports__)) {
    console.log('reload')
    api.reload('5b4fec96', __exports__)
  }
  
  module.hot.accept("./document.vue?vue&type=template&id=5b4fec96&scoped=true", () => {
    console.log('re-render')
    api.rerender('5b4fec96', render)
  })

}


export default __exports__